(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["azimi-store-finder-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('[data-azimi-finder]').forEach(root => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const toggle = root.querySelector('[data-azimi-finder-toggle]');
      const dialog = root.querySelector('[data-azimi-finder-dialog]');
      const close = root.querySelector('[data-azimi-finder-close]');
      const form = root.querySelector('[data-azimi-finder-form]');
      const input = root.querySelector('[data-azimi-finder-input]');
      const welcome = root.querySelector('[data-azimi-finder-welcome]');
      const region = root.querySelector('[data-azimi-finder-results-region]');
      const count = root.querySelector('[data-azimi-finder-count]');
      const results = root.querySelector('[data-azimi-finder-results]');
      const clear = root.querySelector('[data-azimi-finder-clear]');
      const stores = JSON.parse(root.querySelector('[data-azimi-finder-stores]').textContent || '[]');
      const copy = JSON.parse(root.querySelector('[data-azimi-finder-copy]').textContent || '{}');
      let matches = [];
      let visibleCount = 6;
      let searchTimer;

      const normalize = value => (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      const escapeHtml = value => (value || '').toString().replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
      const fullAddress = store => `${store.address}, ${store.city}, ${store.state} ${store.zip}, ${store.country || 'USA'}`;
      const mapAddress = store => encodeURIComponent(fullAddress(store));
      const stateNames = { ca: 'california', md: 'maryland', tx: 'texas', va: 'virginia' };

      function scoreStore(store, query) {
        const name = normalize(store.name);
        const city = normalize(store.city);
        const state = normalize(store.state);
        const zip = normalize(store.zip);
        const address = normalize(store.address);
        const stateName = stateNames[state] || '';
        if (city === query || zip === query || state === query || stateName === query) return 0;
        if (name === query) return 1;
        if (city.startsWith(query) || zip.startsWith(query) || name.startsWith(query)) return 2;
        if (`${name} ${address} ${city} ${state} ${zip} ${stateName}`.includes(query)) return 3;
        const terms = query.split(/\s+/).filter(Boolean);
        const haystack = `${name} ${address} ${city} ${state} ${zip} ${stateName}`;
        return terms.length && terms.every(term => haystack.includes(term)) ? 4 : 99;
      }

      function findStores(query) {
        const exactCity = stores.some(store => normalize(store.city) === query);
        const exactZip = stores.some(store => normalize(store.zip) === query);
        const exactState = stores.some(store => normalize(store.state) === query || stateNames[normalize(store.state)] === query);
        let found;
        if (exactCity) found = stores.filter(store => normalize(store.city) === query);
        else if (exactZip) found = stores.filter(store => normalize(store.zip) === query);
        else if (exactState) found = stores.filter(store => normalize(store.state) === query || stateNames[normalize(store.state)] === query);
        else {
          found = stores.map(store => ({ store, score: scoreStore(store, query) }))
            .filter(item => item.score < 99)
            .sort((left, right) => left.score - right.score || left.store.city.localeCompare(right.store.city) || left.store.name.localeCompare(right.store.name))
            .map(item => item.store);
        }
        return found.sort((left, right) => left.city.localeCompare(right.city) || left.name.localeCompare(right.name));
      }

      function storeCard(store) {
        const address = escapeHtml(fullAddress(store));
        const destination = mapAddress(store);
        return `<article class="azimi-finder__store">
          <div>
            <h3>${escapeHtml(store.name)}</h3>
            <address>${address}</address>
          </div>
          <div class="azimi-finder__directions">
            <a href="https://www.google.com/maps/dir/?api=1&destination=${destination}" target="_blank" rel="noopener">${escapeHtml(copy.google_maps)}</a>
            <a href="https://maps.apple.com/?daddr=${destination}" target="_blank" rel="noopener">${escapeHtml(copy.apple_maps)}</a>
          </div>
        </article>`;
      }

      function renderCards() {
        if (!matches.length) {
          results.innerHTML = `<div class="azimi-finder__empty"><h3>${escapeHtml(copy.no_results_title)}</h3><p>${escapeHtml(copy.no_results_body)}</p></div>`;
          return;
        }
        const visible = matches.slice(0, visibleCount);
        results.innerHTML = visible.map(storeCard).join('');
        if (visible.length < matches.length) {
          results.insertAdjacentHTML('beforeend', `<button class="azimi-finder__show-more" type="button" data-azimi-finder-more>${escapeHtml(copy.show_more)} (${matches.length - visible.length})</button>`);
        }
      }

      function runSearch() {
        const rawQuery = input.value.trim();
        const query = normalize(rawQuery);
        if (query.length < 2) {
          matches = [];
          visibleCount = 6;
          welcome.hidden = false;
          region.hidden = true;
          return;
        }
        matches = findStores(query);
        visibleCount = 6;
        welcome.hidden = true;
        region.hidden = false;
        const resultLabel = matches.length === 1 ? copy.results_one : copy.results_many;
        count.textContent = resultLabel.replace('[count]', matches.length).replace('[query]', rawQuery);
        renderCards();
      }

      function openDialog() {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('azimi-finder-open');
        window.setTimeout(() => input.focus(), 60);
      }

      function closeDialog() {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      }

      toggle.addEventListener('click', openDialog);
      close.addEventListener('click', closeDialog);
      dialog.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('azimi-finder-open');
        toggle.focus();
      });
      dialog.addEventListener('cancel', () => document.body.classList.remove('azimi-finder-open'));
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        if (outside) closeDialog();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        window.clearTimeout(searchTimer);
        runSearch();
      });
      input.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(runSearch, 180);
      });
      clear.addEventListener('click', () => {
        input.value = '';
        runSearch();
        input.focus();
      });
      root.querySelectorAll('[data-azimi-finder-query]').forEach(button => button.addEventListener('click', () => {
        input.value = button.dataset.azimiFinderQuery;
        runSearch();
        input.focus();
      }));
      results.addEventListener('click', event => {
        const more = event.target.closest('[data-azimi-finder-more]');
        if (!more) return;
        visibleCount += 6;
        renderCards();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
